import {createAbsoluteLink, removeHashAndQueryFromLink} from '../atUtils'

const USER_EVENTS_API_PATH = removeHashAndQueryFromLink(createAbsoluteLink('api/v2/userevents'))
const REQUEST_HEADERS= {
    type: 'application/json',
}

export default function sendUserEvent (event, params) {
    const blob = new Blob([
        JSON.stringify({
            event,
            params: params || {}
        })
    ], REQUEST_HEADERS)

    navigator.sendBeacon(USER_EVENTS_API_PATH, blob)
}


// WEBPACK FOOTER //
// ./web/js/userEvents/sendUserEvent.js